import { render, staticRenderFns } from "./policy-from.vue?vue&type=template&id=4a2b3e6a&scoped=true&"
import script from "./policy-from.vue?vue&type=script&lang=js&"
export * from "./policy-from.vue?vue&type=script&lang=js&"
import style0 from "./policy-from.vue?vue&type=style&index=0&id=4a2b3e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b3e6a",
  null
  
)

export default component.exports